export default "/images/vendor/@coreui/icons/svg/flag/cif-ca.svg?642f4b4f7aa0a8f84c1d8592442b41a6";